import BaseIcon from "./BaseIcon.vue";

export default BaseIcon;
